document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-mixed-product-gallery]').forEach(function (gallery) {
    var thumbs = Array.from(gallery.querySelectorAll('[data-media-thumb]'));
    var items = Array.from(gallery.querySelectorAll('[data-media-item]'));

    function stopMedia(item) {
      var video = item.querySelector('video');
      if (video) video.pause();
      var iframe = item.querySelector('iframe');
      if (iframe && iframe.src) {
        var source = iframe.src;
        iframe.src = '';
        iframe.src = source;
      }
    }

    function showMedia(id) {
      items.forEach(function (item) {
        var active = item.dataset.mediaItem === id;
        if (!active && !item.hidden) stopMedia(item);
        item.hidden = !active;
      });
      thumbs.forEach(function (thumb) {
        var active = thumb.dataset.mediaThumb === id;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { showMedia(thumb.dataset.mediaThumb); });
    });
  });
});
